// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Utilities
import { truncateString } from 'common/utils/helpers';

const CustomTooltipAttribute = ({ tooltipLabel, tooltipValue, percentage }) => (
  <div className="custom-tooltip__label" key={tooltipLabel}>
    {truncateString(`${tooltipLabel}`, 25)}
    <span>{percentage ? ' Percentage: ' : ' Count: '}</span>
    <span className="custom-tooltip__value">
      {`${Math.round(tooltipValue)}${percentage ? '%' : ''}`}
    </span>
  </div>
);

CustomTooltipAttribute.defaultProps = {
  tooltipValue: 0,
  percentage: false,
};

CustomTooltipAttribute.propTypes = {
  tooltipLabel: PropTypes.string.isRequired,
  percentage: PropTypes.bool,
  tooltipValue: PropTypes.string,
};

export default CustomTooltipAttribute;
